import * as classTypes from "Store/classrooms/constants";

const initialState: IClassesReducer = {
  activeClass: null,
  activeClassroomStats: null,
  activeLesson: null,
  activeWorksheet: null,
  activeTest: null,
  classLessonList: [],
  classTests: [],
  classWorksheetList: [],
  classes: [],
  classroomCalendarLoading: false,
  classrooms: [],
  classroomStudents: [],
  classroomsSimplifiedLoading: false
};

const handleActions = (state, action) => {
  switch (action.type) {
    case classTypes.SET_ACTIVE_CLASSROOM:
      return {
        activeClass: { ...action.payload }
      };

    case classTypes.SET_CLASSROOM_ACTIVE_LESSON:
      return {
        activeLesson: { ...action.payload }
      };

    case classTypes.SET_CLASSROOM_LESSONS:
      return {
        classLessonList: [...action.payload]
      };

    case classTypes.SET_CLASSROOM_TESTS:
      return {
        classTests: action.payload
      };

    case classTypes.SET_CLASSROOM_ACTIVE_WORKSHEET:
      return {
        activeWorksheet: { ...action.payload }
      };

    case classTypes.SET_CLASSROOM_WORKSHEETS:
      return {
        classWorksheetList: [...action.payload]
      };

    case classTypes.SET_CLASSROOM_CALENDAR_LOADING:
      return {
        classroomCalendarLoading: action.payload
      };

    case classTypes.SET_CLASSROOMS: {
      return {
        classrooms: action.payload
      };
    }
    case classTypes.SET_CLASSROOM_STATS: {
      const { stats, classroomId } = action.payload;
      return {
        classrooms: [
          ...state.classrooms.map((classroom) =>
            classroom.id === classroomId ? { ...classroom, stats } : classroom
          )
        ]
      };
    }
    case classTypes.SET_CLASSROOM_ACTIVE_TEST: {
      return {
        activeTest: action.payload
      };
    }
    case classTypes.SET_CLASSROOM_STUDENTS: {
      return {
        classroomStudents: action.payload
      };
    }
    case classTypes.SET_CLASSROOM_SUMMARY: {
      const { classroomSummary } = action.payload;
      return {
        activeClass: { ...state.activeClass, ...classroomSummary }
      };
    }
    case classTypes.SET_CLASSROOM_OVERDUE_STATS: {
      return {
        activeClassroomStats: { ...state.activeClassroomStats, ...action.payload.overdue }
      };
    }
    case classTypes.SET_CLASSROOM_PROBLEMS_STATS: {
      return {
        activeClassroomStats: { ...state.activeClassroomStats, ...action.payload.problems }
      };
    }
    case classTypes.SET_CLASSROOMS_SIMPLIFIED_LOADING: {
      return {
        classroomsSimplifiedLoading: action.payload.isLoading
      };
    }
    default:
      return {};
  }
};

const classesReducer = (state = initialState, action) => ({
  ...state,
  ...handleActions(state, action)
});

export default classesReducer;
